import { render, staticRenderFns } from "./TestiLingua.vue?vue&type=template&id=10633c38&scoped=true"
import script from "./TestiLingua.vue?vue&type=script&lang=js"
export * from "./TestiLingua.vue?vue&type=script&lang=js"
import style0 from "./TestiLingua.vue?vue&type=style&index=0&id=10633c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10633c38",
  null
  
)

export default component.exports